// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable selector-class-pattern */
.grd8jUT77Ukvcw7X_C4P {
    z-index: 1301;
    color: var(--select-foreground-color) !important;

    & .MuiSelect-select {
        &:focus-visible, &[aria-expanded="true"] {
            outline: 2px solid var(--select-foreground-color) !important;
        }
    }

    & .MuiSelect-icon {
        top: unset;
        stroke: var(--select-foreground-color);
    }

    & .MuiOutlinedInput-notchedOutline {
        border: none;
    }
}

.V0yX2HqTDNXXYrT6CV2y {
    & .MuiPaper-root {
        background-color: var(--body-background-color);
        box-shadow: 0 20px 24px -4px rgba(0, 0, 0, 0.08), 2px -8px 8px -4px rgba(0, 0, 0, 0.03);
    }   
    
    & .MuiList-root {
        color: var(--select-foreground-color);
        padding-bottom: 0;
        min-width: 140px;
    }
}

.JXVWXQ1GVCbER0d3Gh67 {
    font-size: 1.125rem !important;
    background-color: var(--body-background-color) !important;

    &:hover, &:focus {
        font-weight: 600;
    }

    &:focus {
        border: 2px solid var(--select-border-color); 
    }

    &[aria-selected="true"] { 
        font-weight: 600;
    }

    @media (1px <= width <= 768px) {
        font-size: 1.5rem !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/LanguageSelect/LanguageSelect.module.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;IACI,aAAa;IACb,gDAAgD;;IAEhD;QACI;YACI,4DAA4D;QAChE;IACJ;;IAEA;QACI,UAAU;QACV,sCAAsC;IAC1C;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,8CAA8C;QAC9C,uFAAuF;IAC3F;;IAEA;QACI,qCAAqC;QACrC,iBAAiB;QACjB,gBAAgB;IACpB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,yDAAyD;;IAEzD;QACI,gBAAgB;IACpB;;IAEA;QACI,4CAA4C;IAChD;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,4BAA4B;IAChC;AACJ","sourcesContent":["/* stylelint-disable selector-class-pattern */\n.select {\n    z-index: 1301;\n    color: var(--select-foreground-color) !important;\n\n    & :global(.MuiSelect-select) {\n        &:focus-visible, &[aria-expanded=\"true\"] {\n            outline: 2px solid var(--select-foreground-color) !important;\n        }\n    }\n\n    & :global(.MuiSelect-icon) {\n        top: unset;\n        stroke: var(--select-foreground-color);\n    }\n\n    & :global(.MuiOutlinedInput-notchedOutline) {\n        border: none;\n    }\n}\n\n.menu {\n    & :global(.MuiPaper-root) {\n        background-color: var(--body-background-color);\n        box-shadow: 0 20px 24px -4px rgba(0, 0, 0, 0.08), 2px -8px 8px -4px rgba(0, 0, 0, 0.03);\n    }   \n    \n    & :global(.MuiList-root) {\n        color: var(--select-foreground-color);\n        padding-bottom: 0;\n        min-width: 140px;\n    }\n}\n\n.item {\n    font-size: 1.125rem !important;\n    background-color: var(--body-background-color) !important;\n\n    &:hover, &:focus {\n        font-weight: 600;\n    }\n\n    &:focus {\n        border: 2px solid var(--select-border-color); \n    }\n\n    &[aria-selected=\"true\"] { \n        font-weight: 600;\n    }\n\n    @media (1px <= width <= 768px) {\n        font-size: 1.5rem !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select": `grd8jUT77Ukvcw7X_C4P`,
	"menu": `V0yX2HqTDNXXYrT6CV2y`,
	"item": `JXVWXQ1GVCbER0d3Gh67`
};
module.exports = ___CSS_LOADER_EXPORT___;
